import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';
import { useAppTheme } from '../App';
import { PRIMARY_ORANGE } from '../common/colors';
import HomeIcon from '@mui/icons-material/Home';

const NotFound: React.FC = () => {
    const navigate = useNavigate();
    const { isDarkMode } = useAppTheme();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: '6rem',
                        fontWeight: 700,
                        color: PRIMARY_ORANGE.main,
                        mb: 2,
                    }}
                >
                    404
                </Typography>

                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 600,
                        color: isDarkMode ? '#ececf1' : '#374151',
                        mb: 2,
                    }}
                >
                    Page Not Found
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        color: isDarkMode ? '#c5c5d2' : '#6b7280',
                        mb: 4,
                        maxWidth: '400px',
                    }}
                >
                    The page you&apos;re looking for doesn&apos;t exist or has been moved.
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<HomeIcon />}
                    onClick={() => navigate('/')}
                    sx={{
                        background: PRIMARY_ORANGE.main,
                        color: 'white',
                        fontWeight: 600,
                        borderRadius: 2,
                        px: 4,
                        py: 1.5,
                        '&:hover': {
                            background: PRIMARY_ORANGE.dark,
                        },
                    }}
                >
                    Go Home
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound; 